import React, { useState } from 'react';
import styled from 'styled-components';

import { WhiteSource, RedSource, GreenSource, Plus, Minus, X } from '../../Constants/assets';

const MinusContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    opacity: 0.9;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    :active {
        transform: translateY(1px);
        box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
    }
`;
const NumberContainer = styled.div`
    width: 14%;
    text-align: center;
    line-height: 220%;
    font-size: 1rem;
    font-weight: bold;
`;
const PlusContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    opacity: 0.9;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    :active {
        transform: translateY(1px);
        box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
    }
`;
const CenterContainer = styled.div`
    width: 90%;
    height: 33%;
    display: flex;
    justify-content: space-between;
`;
const SideContainer = styled.div`
    width: 50%;
    height: 100%;
`;
const ExchangeContainer = styled.div`
    display: flex;
    margin-bottom: 5%;
    height: 40%;
    align-items: center;
`;
const Price = styled.div`
    font-size: 16px;
    line-height: 19px;
    width: 26%;
`;

// TODO: Fix this, this is temporary fix
export default function ResourcesExchangeItem({
    price,
    icon,
    tertiaryIcon,
    secondaryIcon,
    resourceType,
}) {
    const [white, setWhite] = useState(0);
    const [red, setRed] = useState(0);
    const [green, setGreen] = useState(0);

    const decrement = resource => {
        if (resource === 'white' && white > 0) setWhite(currentResource => currentResource - 1);
        else if (resource === 'red' && red > 0) setRed(currentResource => currentResource - 1);
        else if (resource === 'green' && green > 0)
            setGreen(currentResource => currentResource - 1);
    };

    const increment = resource => {
        if (resource === 'white') setWhite(currentResource => currentResource + 1);
        else if (resource === 'red') setRed(currentResource => currentResource + 1);
        else if (resource === 'green') setGreen(currentResource => currentResource + 1);
    };

    const resources = {
        white: <WhiteSource style={{ width: '15%' }} />,
        red: <RedSource style={{ width: '15%' }} />,
        green: <GreenSource style={{ width: '15%' }} />,
    };
    return (
        <CenterContainer>
            <SideContainer>
                <ExchangeContainer>
                    {resources[icon]}
                    <Price> ${price}</Price>
                    <MinusContainer
                        style={{ cursor: 'pointer' }}
                        onClick={() => decrement('white')}
                    >
                        <Minus />
                    </MinusContainer>
                    <NumberContainer style={{ width: '17%' }}>{resourceType}</NumberContainer>
                    <PlusContainer style={{ cursor: 'pointer' }} onClick={() => increment('white')}>
                        <Plus />
                    </PlusContainer>
                </ExchangeContainer>
            </SideContainer>
            <SideContainer>
                <ExchangeContainer>
                    <Price style={{ fontSize: '0.75rem' }}>Exchange</Price>
                    {resources[secondaryIcon]}
                    <MinusContainer
                        style={{ cursor: 'pointer' }}
                        onClick={() => decrement('white')}
                    >
                        <Minus />
                    </MinusContainer>
                    <NumberContainer style={{ width: '17%' }}>?</NumberContainer>
                    <PlusContainer style={{ cursor: 'pointer' }} onClick={() => increment('white')}>
                        <Plus />
                    </PlusContainer>
                </ExchangeContainer>
                <ExchangeContainer>
                    <Price style={{ fontSize: '0.75rem' }}>Exchange</Price>
                    {resources[tertiaryIcon]}
                    <MinusContainer
                        style={{ cursor: 'pointer' }}
                        onClick={() => decrement('white')}
                    >
                        <Minus />
                    </MinusContainer>
                    <NumberContainer style={{ width: '17%' }}>?</NumberContainer>
                    <PlusContainer style={{ cursor: 'pointer' }} onClick={() => increment('white')}>
                        <Plus />
                    </PlusContainer>
                </ExchangeContainer>
            </SideContainer>
        </CenterContainer>
    );
}
